<template>
  <div style="width: 100%">
    <div class="container">
      <div class="title">
        <div class="text" @click="titleClick('msgCode')">
          <span :class="{text_click:loginType === 'msgCode'}">短信登录</span>
          <div :class="{underline:loginType === 'msgCode'}"></div>
        </div>
        <div class="text" @click="titleClick('password')">
          <span :class="{text_click:loginType === 'password'}">密码登录</span>
          <div :class="{underline:loginType === 'password'}"></div>
        </div>
      </div>
      <Form ref="loginForm" :model="loginForm" :rules="rules" inline>
        <div class="body" v-if="loginType === 'msgCode'">
          <Form-item prop="username">
            <div class="body_input" :class="focusClass === 'username'?'focus':''">
              <img src="../../../static/img/home/phone.png" alt="" style="width: 16px;height: 16px;margin-right: 16px;">
              <Input placeholder="请输入手机号码" @on-focus="focusClass = 'username'" @on-blur="focusClass = ''"
                     v-model.trim="loginForm.username" style="width: 100%;"/>
            </div>
          </Form-item>
          <Form-item prop="msgCode">
            <div class="body_input" :class="focusClass === 'msgCode'?'focus':''" style="margin-top: 12px;">
              <img src="../../../static/img/home/yzm.png" alt="" style="width: 16px;height: 16px;margin-right: 16px;">
              <Input placeholder="请输入验证码" @on-focus="focusClass = 'msgCode'" @on-blur="focusClass = ''"
                     v-model.trim="loginForm.msgCode" style="width: 100%;"/>
              <Button type="text" v-if="!is_code_click" @click="getCode">获取验证码</Button>
              <span style="color: #ccc" v-else>{{ code_time }}s</span>
            </div>
          </Form-item>

        </div>
        <div class="body" v-if="loginType === 'password'">
          <Form-item prop="username">
            <div class="body_input" :class="focusClass === 'username'?'focus':''">
              <img src="../../../static/img/home/phone.png" alt="" style="width: 16px;height: 16px;margin-right: 16px;">
              <Input placeholder="请输入手机号码" @on-focus="focusClass = 'username'" @on-blur="focusClass = ''"
                     v-model.trim="loginForm.username" style="width: 100%;"/>
            </div>
          </Form-item>
          <Form-item prop="password">
            <div class="body_input" :class="focusClass === 'password'?'focus':''" style="margin-top: 12px;">
              <img src="../../../static/img/home/pass.png" alt="" style="width: 16px;height: 16px;margin-right: 16px;">
              <Input type="password" v-model.trim="loginForm.password" @on-focus="focusClass = 'password'"
                     @on-blur="focusClass = ''" placeholder="请输入密码" style="width: 100%;"/>
            </div>
          </Form-item>

        </div>
        <Button class="login_button" long @click="loginClick" :loading="loading">
          <span v-if="!loading">登录</span>
          <span v-else>登录中...</span>
        </Button>
      </Form>
      <div style="display: flex;justify-content: space-between">
        <Checkbox v-model="single" style="color: #333;font-size: 14px;" @on-change="rememberUser">记住用户名</Checkbox>
        <div>
          <span style="color: #61A842;font-size: 14px;cursor: pointer" @click="handleRegister()">注册账户</span>
          <span style="color: #61A842;font-size: 14px;cursor: pointer;margin-left: 12px;"
                v-if="loginType === 'password'" @click="handlePassword()">忘记密码</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {authLogin, sendSmsCode} from '@/api/sys';
import Cookies from 'js-cookie'
import {shoppingCart} from '@/api/PersonalCenter';

export default {
  name: 'LoginCom',
  data() {
    const validatePhone = (rule, value, callback) => {
      const reg = /^((1[0-9][0-9])+\d{8})$/;
      if (!value) {
        return callback(new Error('请输入手机号'));
      } else if (value && !reg.test(value)) {
        return callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    return {
      is_d_click: true,
      is_m_click: false,
      single: false,
      is_code_click: false,
      loginType: 'msgCode',
      loading: false,
      code_time: 60,
      loginForm: {
        username: '',
        password: '',
        msgCode: '',
      },
      focusClass: '',
      rules: {
        username: [
          {trigger: 'blur', validator: validatePhone}
        ],
        msgCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ]
      }

    };
  },
  props: {
    isDialogLogin: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (Cookies.get('username_m')) {
      this.single = true;
      this.loginForm.username = Cookies.get('username_m')
    }
  },

  methods: {
    rememberUser(v) {
      // if (v) {
      //   Cookies.set('username_m', this.loginForm.username)
      // } else {
      //   Cookies.remove('username_m')
      // }
    },
    handleRegister() {
      this.$router.push('/UserRegister');
    },
    handlePassword() {
      this.$router.push('/UserPassword');
    },
    titleClick(type) {
      if (this.loginType === type) return;
      this.loginType = type;
      // this[p] = !this[p];
      // this[q] = !this[q];
      this.$refs.loginForm.resetFields();
    },
    getCode() {
      // let res = /^1[34578]\d{9}$/;
      // if (!res.test(this.loginForm.username)) {
      //   this.$message.error("手机号输入不正确");
      //   return;
      // }
      this.$refs.loginForm.validateField('username', async (res) => {
        if (!res) {
          const res = await sendSmsCode({phone: this.loginForm.username});
          if (res.code === 200) {
            this.$Message.success('验证码发送成功！');
          } else {
            this.$Message.err(res.msg);
          }
          this.is_code_click = true;
          let time = setInterval(() => {
            if (this.code_time > 1) {
              this.code_time--;
            } else {
              this.is_code_click = false;
              this.code_time = 60;
              clearInterval(time);
            }
          }, 1000);
        }
      });
      // else{

      // let params = {
      //   phone:this.loginForm.username
      // }
      // getLoginCode(params);
      // }
    },
    classifyArrayGroupBySameFieldAlpha (arr, filed) {
      let temObj = {};
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i];
        if (!temObj[item[filed]]) {
          temObj[item[filed]] = [item];
        } else {
          temObj[item[filed]].push(item);
        }
      }
      let resArr = [];
      Object.keys(temObj).forEach(key => {
        resArr.push({
          key: key,
          data: temObj[key],
        });
      });
      return resArr;
    },

    loginClick() {
      this.$refs['loginForm'].validate(async (valid) => {
        if (valid) {
          this.loginForm.type = this.loginType === 'msgCode' ? 0 : 1;
          this.loading = true;
          this.$store.dispatch('login', this.loginForm).then(async (res) => {
            const cart = sessionStorage.getItem('cookieCart') ? JSON.parse(sessionStorage.getItem('cookieCart')) :[]
            if (cart.length > 0){
              let res1 = this.classifyArrayGroupBySameFieldAlpha(cart,'storeId')
              const res2 = res1.map(v=>{
                v.data = v.data.map(t=>{
                  return{
                    'addressId': t.addressId,
                    'brand': t.brand,
                    'brandId': 0,
                    'couponId': 0,
                    'createTime': '',
                    'categoryName': t.categoryName,
                    'productUrl': t.productUrl,
                    'saleUnitPrice': t.saleUnitPrice,
                    'measureUnit': t.measureUnit,
                    'deleteStatus': 0,
                    'deliveryCompany': t.deliveryCompany,
                    'deliverySn': '',
                    'deliveryTime': '',
                    'endDate': '',
                    'freightAmount': 0,
                    'goodAmount': 0,
                    'goodsId': t.goodsId,
                    'goodsName': '',
                    'groupId': 0,
                    'id': 0,
                    'memberId': 0,
                    'memberUsername': '',
                    'note': '',
                    'orderSn': '',
                    'payType': 0,
                    'paymentTime': '',
                    'prepayId': '',
                    'quantity': t.quantity,
                    'receiverCity': t.receiverCity,
                    'receiverDetailAddress': '',
                    'receiverId': 0,
                    'receiverName': '',
                    'receiverPhone': '',
                    'receiverPostCode': '',
                    'receiverProvince': '',
                    'receiverRegion': '',
                    'sendOrderNum': '',
                    'sku1': t.sku1,
                    'sourceType': 0,
                    'startDate': '',
                    'status': 0,
                    'storeId': t.storeId,
                    'storeName': '',
                    'supplyId': 0,
                    'taxContent': '',
                    'totalAmount': 0,
                    'transactionModeName': t.transactionModeName,
                    'transactionModeType': t.transactionModeType,
                    'unitAmount': 0,
                    'whetherSell': ''
                  }
                })
                return{
                  ...v
                }
              })
              const obj = {};
              for (let x in res2){
                obj[res2[x].key] = res2[x].data;
              }
              const response = await shoppingCart(obj)
              if (response.code === 200){
                if (this.$route.path === '/cart'){
                  location.reload();
                }
                sessionStorage.clear()
              }



            }
            if (this.single) {
              Cookies.set('username_m', this.loginForm.username)
            } else {
              Cookies.remove('username_m')
            }
            this.loading = false;
            if (this.isDialogLogin) {
              this.$emit('closeDialog');
            } else {
              this.$router.push({path: '/'});
            }

          }).catch(err => {
            this.loading = false;
            console.log(err);
          });

        } else {
          return;
        }
      });

    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 350px;
  height: 410px;
  padding: 40px 34px 0;
  background-color: #fff;
}

.error {
  display: flex;
  align-items: center;
  margin: 4px 0;
  background-color: #FFF0ED;
  border-radius: 3px 3px;
  color: #D54941;
  line-height: 20px;
  height: 24px;
  font-size: 12px;

  img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
    margin-left: 8px;
  }
}

/deep/ .ivu-form-item {
  margin-bottom: 0;
  margin-right: 0;
  width: 100%;
}


/deep/ .ivu-form-item-error-tip {
  position: static;
  display: flex;
  align-items: center;
  margin-top: 4px;
  background-color: #FFF0ED;
  border-radius: 3px 3px;
  color: #D54941;
  line-height: 20px;
  height: 24px;
  font-size: 12px;
  padding: 4px 0;

  &:before {
    content: '';
    display: block;
    width: 14px;
    height: 14px;
    background-image: url("../../../static/img/login/error.png");
    background-size: 100% 100%;
    margin-right: 5px;
    margin-left: 8px;
  }

}

.title {
  display: flex;
  height: 26px;
  margin-bottom: 32px;
  cursor: pointer;

  .text {
    flex: 1;
    text-align: center;
    color: #333;
    font-weight: 600;
    font-size: 18px;
  }

  .text_click {
    color: #61A842;
  }

  .underline {
    width: 32px;
    margin: auto;
    margin-top: 8px;
    border-bottom: 2px solid #61A842;
  }
}

.body {
  .body_input {
    display: flex;
    align-items: center;
    padding: 7px 16px;
    border: 1px solid #E7E7E7;

  }

  .focus {
    outline: none;
    border: solid 1px #61A842;
  }


  /deep/ {
    .ivu-input {
      border: none;
      font-size: 14px;
      color: #333333;
    }

    .ivu-input:focus {
      outline: none;
      box-shadow: none;
    }

    .ivu-btn-text {
      color: #61A842;
      box-shadow: none;
    }

    .ivu-btn-text:focus {
      box-shadow: none;
    }

  }
}

.login_button {
  height: 48px;
  margin-top: 32px;
  margin-bottom: 17px;
  background-color: #61A842;
  color: #fff;
  font-size: 16px;
}

.login_button:hover {
  height: 48px;
  margin-top: 32px;
  margin-bottom: 17px;
  background-color: #61A842;
  color: #fff;
  font-size: 16px;
  border: none;
}

/deep/ {
  .ivu-checkbox-checked .ivu-checkbox-inner {
    background-color: #61A842;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/hm_personal/LoginCom.vue